import React from "react";

import { usePregnancies } from "features/pregnancy/hooks/usePregnancies";
import {
  formatGestation,
  getGestation,
  selectCurrentPregnancy,
} from "features/pregnancy/utils/currentPregnancy";

import styles from "./PregnancyAlert.module.css";

/**
 * "Pregnant / Currently 16 weeks 6 days pregnant" on the patient card.
 *
 * Whether she is pregnant comes from the pregnancy's own completion state, not from the estimated
 * due date (KIN-1941). Reading it from the due date failed in both directions: the box disappeared
 * once that date passed, exactly when a post-dates pregnancy is most worth flagging, and it went
 * on announcing a gestation for weeks after a delivery, miscarriage or termination.
 */
const PregnancyAlert = ({ patientId }) => {
  const { data: pregnancies } = usePregnancies(patientId);

  const currentPregnancy = selectCurrentPregnancy(pregnancies);

  if (!currentPregnancy) return null;

  const gestationLabel = formatGestation(
    getGestation(currentPregnancy.estimatedDueDate)
  );

  return (
    <div className={styles.box}>
      <p className={styles.title}>Pregnant</p>
      {/* An open pregnancy with no usable due date is still worth showing — the heading is the
          part that matters on the card, and a missing gestation should not hide it. */}
      {!!gestationLabel && (
        <p className={styles.text}>Currently {gestationLabel} pregnant</p>
      )}
    </div>
  );
};

export { PregnancyAlert };
